import { useRef, useState } from 'react';
import axios from '../../../lib/axios';
import {
  CLEAR_MONEY_DRIVER_FINANCIAL,
  CREATE_SUBMISSION,
  PAY_MONEY_DRIVER_FINANCIAL,
} from '../../../lib/endpoints/driverFinancial';
import { DriverFinancialModel } from '../../../models/driverFinancial';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';
import { generateImageFileNameWithRandomName } from '../../../utils/generateImageFileName';
import { OrderDriverFinancial } from '../../../models/orderDriverFinancial';
import { totalDistance } from '../../../utils/sumTotalDistance';

interface Props {
  onClose: VoidFunction;
  selectedData: DriverFinancialModel;
  onFetchData: Function;
}

const useDetailFormDriverFinancialController = ({ selectedData, onClose, onFetchData }: Props) => {
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [openPayRider, setOpenPayRider] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [openViewOrder, setOpenViewOrder] = useState<boolean>(false);

  const totalMoney = useRef<HTMLInputElement>(null!);

  const handleOpenViewOrderDetail = () => {
    setOpenViewOrder(true);
  };

  const handleCloseViewOrderDetail = () => {
    setOpenViewOrder(false);
  };

  const handleOpenConfirmPayRider = () => {
    setOpenPayRider(true);
  };

  const handleCloseConfirmPayRider = () => {
    setOpenPayRider(false);
  };

  const handleSubmitPayDriver = () => {
    handlePayMoneyDriver();
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const rows = selectedData?.balanceSubmission?.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE + DEFAULT_ROWS_PER_PAGE
  );

  const countPagination = Math.ceil(
    selectedData?.balanceSubmission?.length / DEFAULT_ROWS_PER_PAGE
  );
  const balanceSubmissionMoney = selectedData?.balanceSubmission?.reduce(
    (total, item) => total + (item?.totalMoney || 0),
    0
  );
  const totalBalance = selectedData?.rider?.totalBalance?.total;

  const totalOnePay =
    selectedData?.ordersOnePay?.totalMoney === undefined
      ? 0
      : selectedData?.ordersOnePay?.totalMoney;

  const totalCash =
    selectedData?.ordersCash?.totalMoney === undefined ? 0 : selectedData?.ordersCash?.totalMoney;

  const totalReturnOrder =
    selectedData?.ordersReturn?.totalMoney === undefined
      ? 0
      : selectedData?.ordersReturn?.totalMoney;

  const totalSum = totalCash + totalOnePay;
  const totalMoneyBalance = selectedData?.rider?.totalBalance?.total;

  const orderCashDistance = selectedData?.ordersCash?.orders?.map(
    (item: OrderDriverFinancial) => item?.distance
  );
  const orderOnePayDistance = selectedData?.ordersOnePay?.orders?.map(
    (item: OrderDriverFinancial) => item?.distance
  );
  const orderReturnDistance = selectedData?.ordersReturn?.orders?.map(
    (item: OrderDriverFinancial) => item?.distance
  );

  const distanceRiderGot = totalDistance(orderCashDistance, orderOnePayDistance, orderReturnDistance);

  const handlePayMoneyDriver = async () => {
    try {
      setLoadingButton(true);
      await axios.post(PAY_MONEY_DRIVER_FINANCIAL + selectedData?.riderId);
      onClose();
      await onFetchData();
    } catch (err) {
      window.alert(err);
    } finally {
      setLoadingButton(false);
    }
  };

  return {
    loadingButton,
    handleSubmitPayDriver,
    handleCloseConfirmPayRider,
    handleOpenConfirmPayRider,
    openPayRider,
    errorMessage,
    handleChangePage,
    currentPage,
    rows,
    totalMoney,
    countPagination,
    balanceSubmissionMoney,
    totalBalance,
    totalOnePay,
    totalSum,
    totalMoneyBalance,
    handleCloseViewOrderDetail,
    handleOpenViewOrderDetail,
    openViewOrder,
    distanceRiderGot,
    totalReturnOrder,
  };
};

export default useDetailFormDriverFinancialController;
